import * as React from "react";
import FrozenIcon, { FrozenResourceType } from "~/components/DeploymentFreezes/FrozenIcon";
import styles from "./style.module.less";
export default () => (<span className={styles.phaseIcon}>
        <FrozenIcon for={FrozenResourceType.Environment}/>
    </span>);
